<style scoped lang="scss">
.bgcover{
  position: absolute;
  width:100%;
  height:100%;
  background-color:transparent;
  top:0px;
  left:0px;
  visibility: hidden;
  z-index:999;
}
.aui-mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #fff;
    opacity: 0.3;
    z-index: 999;
    -webkit-transition: opacity .3s,-webkit-transform .3s;
    transition: opacity .3s,transform .3s;
}
.t-loading01{
  // width: 13rem;
  // height:10rem;
  // position: absolute;
  // top:50%;
  // margin-top:-6rem;
  // z-index:9999;
  // left:50%;
  // margin-left:-6.5rem;
  // background-color:rgba(0,0,0,0.6);
  // border-radius: 3px;
  // opacity:1;
  // visibility: hidden;

  transition:all 800ms ease;
  .load7{
    position:absolute;
    height:50px;
    top:-70px;
    left:70px;
    z-index:1000;
  }
  .load8{
    -webkit-transition-property: -webkit-transform;
    -webkit-transition-duration: 1s;
    -moz-transition-property: -moz-transform;
    -moz-transition-duration: 1s;
    -webkit-animation: rotate 2s linear infinite;
    -moz-animation: rotate 2s linear infinite;
    -o-animation: rotate 2s linear infinite;
    animation: rotate 2s linear infinite;
    transform-origin:50% 50%;
    position: absolute;
    left: 50%;
    top:50%;
    margin-left:-3rem;
    margin-top:-4.5rem;
  }
  #ajaxloader2 {
    top: 50%;
    position: absolute;
    left: 50%;
    width: 100px;
    height: 100px;
    margin-top: -50px;
    margin-left: -50px;
    z-index: 1000;
}
#ajaxloader2 .outer {
  border: 5px solid rgba(0, 183, 229, 0.9);
  opacity: .9;
  width: 50px;
  height: 50px;
  border-top-color: transparent;
  border-bottom-color: transparent;
  border-radius: 50%;
  -webkit-box-shadow: 0 0 35px rgba(0, 61, 76, 0.9);
  -moz-box-shadow: 0 0 35px rgba(0, 61, 76, 0.9);
  box-shadow: 0 0 35px rgba(0, 61, 76, 0.9);
  -webkit-animation: spin-right 0.5s linear infinite normal;
  -moz-animation: spin-right 0.5s linear infinite normal;
  -ms-animation: spin-right 0.5s linear infinite normal;
  animation: spin-right 0.5s linear infinite normal;
  -webkit-animation-delay: 0;
  -moz-animation-delay: 0;
  -o-animation-delay: 0;
  animation-delay: 0;
  margin: 0 auto;
}
#ajaxloader2 .inner {
  display: block;
  width: 30px;
  height: 30px;
  border: 5px solid rgba(0, 183, 229, 0.9);
  opacity: .9;
  border-radius: 50%;
  border-left-color: transparent;
  border-bottom-color: transparent;
  -webkit-box-shadow: 0 0 35px rgba(0, 61, 76, 0.9);
  -moz-box-shadow: 0 0 35px rgba(0, 61, 76, 0.9);
  box-shadow: 0 0 35px rgba(0, 61, 76, 0.9);
  position: relative;
  top: -50px;
  margin: 10px auto;
  -webkit-animation: spin-left 0.5s linear infinite normal;
  -moz-animation: spin-left 0.5s linear infinite normal;
  -ms-animation: spin-left 0.5s linear infinite normal;
  animation: spin-left 0.5s linear infinite normal;
  -webkit-animation-delay: 0;
  -moz-animation-delay: 0;
  -o-animation-delay: 0;
  animation-delay: 0;
}
}
.active{
  opacity: 1;
  visibility: visible;
}
.load7 .loader:before,
.load7 .loader:after,
.load7 .loader {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.8s infinite ease-in-out;
  animation: load7 1.8s infinite ease-in-out;
}
.load7 .loader {
  margin: 8em auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.load7 .loader:before {
  left: -3.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.load7 .loader:after {
  left: 3.5em;
}
.load7 .loader:before,
.loader:after {
  content: '';
  position: absolute;
  top: 0;
  z-index:1000;
}
@-webkit-keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em rgba(255,255,255,0.7);
  }
  40% {
    box-shadow: 0 2.5em 0 0 rgba(255,255,255,0.7);
  }
}
@keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em rgba(255,255,255,0.7);
  }
  40% {
    box-shadow: 0 2.5em 0 0 rgba(255,255,255,0.7);
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-active {
  opacity: 0
}

@-webkit-keyframes rotate{from{-webkit-transform: rotate(0deg)}
    to{-webkit-transform: rotate(360deg)}
}
@-moz-keyframes rotate{from{-moz-transform: rotate(0deg)}
    to{-moz-transform: rotate(359deg)}
}
@-o-keyframes rotate{from{-o-transform: rotate(0deg)}
    to{-o-transform: rotate(359deg)}
}
@keyframes rotate{from{transform: rotate(0deg)}
    to{transform: rotate(359deg)}
}
.errornotice{
  width:30rem;
  background-color:white;
  position:absolute;
  top:50%;
  left:50%;
  z-index:999;
  border-radius:.3rem;
  margin-top:-9rem;
  margin-left:-15rem;
  box-shadow: 1px 1px 1px #ddd;
  border:1px solid #ddd;
  h3{
    padding:.8rem 1rem;
    text-align:center;
  }
  div{
    text-align:center;
    padding:.5rem 1rem;
  }
  p{
    margin-top:1rem;
    border-top:1px solid #ebebbe;
    padding:.6rem;
    color:#26B4FF;
    text-align:center;
  }
}
path {
  stroke-dasharray: 600;
  stroke-dashoffset: 600;
  -webkit-animation: dash 1s linear infinite;
  animation: dash 1s linear infinite;
  stroke:white;
  //#1482D3;
}

@-webkit-keyframes dash {
  to{
      stroke-dashoffset:1;
  }
}
@keyframes dash {
  to{
      stroke-dashoffset:1;
  }
}
@keyframes spin-right {
  from {
    transform: rotate(0deg);
    opacity: 0.2;
  }
  50% {
    transform: rotate(180deg);
    opacity: 1.0;
  }
  to {
    transform: rotate(360deg);
    opacity: 0.2;
  }
}
@-moz-keyframes spin-right {
  from {
    -moz-transform: rotate(0deg);
    opacity: 0.2;
  }
  50% {
    -moz-transform: rotate(180deg);
    opacity: 1.0;
  }
  to {
    -moz-transform: rotate(360deg);
    opacity: 0.2;
  }
}
@-webkit-keyframes spin-right {
  from {
    -webkit-transform: rotate(0deg);
    opacity: 0.2;
  }
  50% {
    -webkit-transform: rotate(180deg);
    opacity: 1.0;
  }
  to {
    -webkit-transform: rotate(360deg);
    opacity: 0.2;
  }
}
@keyframes spin-left {
  from {
    transform: rotate(0deg);
    opacity: 0.2;
  }
  50% {
    transform: rotate(-180deg);
    opacity: 1.0;
  }
  to {
    transform: rotate(-360deg);
    opacity: 0.2;
  }
}
@-moz-keyframes spin-left {
  from {
    -moz-transform: rotate(0deg);
    opacity: 0.2;
  }
  50% {
    -moz-transform: rotate(-180deg);
    opacity: 1.0;
  }
  to {
    -moz-transform: rotate(-360deg);
    opacity: 0.2;
  }
}
@-webkit-keyframes spin-left {
  from {
    -webkit-transform: rotate(0deg);
    opacity: 0.2;
  }
  50% {
    -webkit-transform: rotate(-180deg);
    opacity: 1.0;
  }
  to {
    -webkit-transform: rotate(-360deg);
    opacity: 0.2;
  }
}
</style>
<template>
  <div @touchmove.prevent>
      <div class="t-loading01" v-if="show">
          <!-- <div class="load7">
              <div class="loader"></div>
          </div> v-if="show=='error'" -->
          <div class="aui-mask"></div>
          <div id="ajaxloader2">
            <div class="outer"></div>
            <div class="inner"></div>
          </div>
          <!-- <div v-if="version=='mobile'" style="z-index:1000;position:absolute;width:100%;left:50%;margin-left:-27px;top:50%;margin-top:-28px;">
              <svg width="55" height="55" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <title>background</title>
                  <rect x="-1" y="-1" width="57" height="57" id="canvas_background" fill="none"/>
                  <g id="canvasGrid" display="none">
                  <rect id="svg_1" width="100%" height="100%" x="0" y="0" stroke-width="0" fill="url(#gridpattern)"/>
                  </g>
                </g>
                <g>
                  <title>Layer 1</title>
                  <path fill="#fff" stroke="#000" stroke-width="1.5" stroke-opacity="null" fill-opacity="null" d="m289.20705,162.99559" id="svg_3"/>
                  <path stroke="#000" fill="none" stroke-width="2" d="m52.071466,13.321671c0,0 -0.136888,-6.990239 -0.136888,-6.990239c0,0 -24.503439,-4.616205 -24.503439,-4.616205c0,0 -24.914103,5.011883 -24.914103,5.011883c0,34.291764 25.187879,46.557664 25.187879,46.557664c22.450069,-15.299403 24.777215,-33.764197 24.777215,-33.764197c0.136888,0 -16.563772,0 -16.563772,0c0,0 5.201856,-5.275661 5.201856,-5.275661c0,0 -8.761007,-1.582702 -8.761007,-1.582702c0,0 -6.570761,6.330795 -6.570761,6.330795c0,0 -0.136888,-6.198894 -0.136888,-6.198894c0,0 -6.981425,-0.131901 -6.981425,-0.131901c0,0 0.273788,20.838841 0.273788,20.838841c0,0 5.749408,6.858362 5.749408,6.858362c-0.273776,-0.527567 0.136888,-10.41942 0.136888,-10.41942c0,0 7.52899,8.045374 7.52899,8.045374c0,0 4.928055,-5.671327 4.928055,-5.803228c0,-0.131889 -4.243603,-4.220526 -4.243603,-4.220526c0,0 8.35033,0 8.35033,0c-2.600922,11.210765 -13.14151,17.54156 -13.14151,17.54156c-17.248225,-10.287531 -18.343354,-33.36853 -18.343354,-33.36853c-0.273776,0 17.111337,-2.769713 17.111337,-2.769713c0,0 25.051003,3.956736 25.051003,3.956736l0,0.000001z" id="svg_7"/>
                </g>
              </svg>
          </div>
          <div v-else class="load8">
            <i class="iconfont icon-jiazai" style="font-size:7rem;color:white;"></i>
          </div> -->

      </div>
      <!-- <div class="bgcover" :class="show==true?'active':''" :style="{'background-color':loadbg?'#ebebeb':'transparent'}"></div>
      <div class="errornotice" v-if="show=='error'">
        <h3>系统提醒</h3>
        <div>{{notice}}</div>
        <p @click="closenotice">确定</p>
      </div> -->
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { setTimeout } from 'timers';
export default {
  name: 'TLoading',
  data () {
    return {
      show:false,
      notice:"",
      version:""
    }
  },
  computed: {
    ...mapGetters([
      // 'device',
      // 'loadbg'
    ])
  },
  methods:{
    closenotice(){
      this.show = false;
    }
  },
  mounted(){
    // this.version = this.device;
    this.$nextTick(()=>{
      let $footer = document.getElementsByClassName("t-footer");
      // this.$el.querySelector(".bgcover").style.height=document.documentElement.offsetHeight-($footer.length>0?$footer.offsetHeight:0)+ "px";
    });

    // 配置位移矢量 一共走100步
    // var path = document.getElementById("svg_7");
    // var STEP = path.getTotalLength();
    // var curStep = 0;
    // var lineAnim = function(){
    //     curStep++;

    //     if(curStep==Math.ceil(STEP-200)){
    //         document.getElementById("svg_7").setAttribute("fill","#1482D3");
    //         clearInterval(time);
    //         setTimeout(()=>{
    //             curStep=0
    //             time = setInterval(lineAnim,1);
    //             document.getElementById("svg_7").setAttribute("fill","white");
    //         },6000);
    //     }
    // }
    // var time = setInterval(lineAnim,1);
    // var path = document.getElementById("svg_7");
    // var $car = document.getElementById("car");
    // var STEP = path.getTotalLength();
    // var curStep = 0;
    // var timer = null;
    // // 最重要的两个属性  获取长度，以及每个点的坐标
    // var totalLength = path.getTotalLength();
    // var initPosition = path.getPointAtLength(0);
    // var prePosition = initPosition;
    // var curPosition = initPosition;

    // // 获取前进切线角度
    // function getRotate(a, b) {
    //     var k = (b.y - a.y) / (b.x - a.x);
    //     var rotate = Math.atan(k) * 180 / Math.PI;
    //     return k < 0 ? rotate + 90 : rotate - 90;
    // }

    // // 定位car
    // $car.style.left = initPosition.x +"px";
    // $car.style.top = initPosition.y +"px";
    // $car.style['-webkit-transform'] = 'translate(-2px, 0) rotate(' + getRotate(curPosition , path.getPointAtLength(1)) +'deg)';
    // //$car.style.display = "block";

    // // // 定时器控制前进
    // var carAnimate =  function() {
    //     initPosition = path.getPointAtLength(curStep);
    //     //document.getElementById("svg_7").setAttribute("fill","white");
    //     if (curStep!=STEP) {
    //         curStep++;
    //         curPosition = path.getPointAtLength(totalLength/STEP * curStep);
    //         $car.style.left = initPosition.x +"px";
    //         $car.style.top = initPosition.y +"px";
    //         $car.style['-webkit-transform'] = 'translate(-2px, 0) rotate(' + getRotate(curPosition , path.getPointAtLength(1)) +'deg)';
    //         //$car.style.display = "block";
    //         prePosition = curPosition;
    //     } else {

    //         clearInterval(timer);

    //         setTimeout(function(){
    //             curStep=0;
    //             timer = setInterval(carAnimate,1)
    //         },100);
    //     }

    // }
    // timer = setInterval(carAnimate, 1)
  },
  watch:{
    "$store.state.loading":function(){
      console.log(this.$store.state.loading,'改变load');
      if(typeof this.$store.state.loading == "string"){
        // this.show = 'error';
        // this.notice = this.$store.state.loading;
      }
      else{
        this.show = this.$store.state.loading;
        setTimeout(()=>{
          this.show = false;
        },10000)
      }
    }
  }
}
</script>
